import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_244fxqfjt6: FaireBrandEntity = {
  token: "b_244fxqfjt6",
  type: "brand",
  name: "Sauce Bae",
  avatarUrl:
    "https://cdn.faire.com/fastly/cd3e07d9a76dbc72b20c3ed39483cbf01f51283289f6600c8dac871d2c22b0a5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/011acfd466be8f7300a2e9026c3e251d5a5bace74940487e594f9ab1021ef476.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cd3e07d9a76dbc72b20c3ed39483cbf01f51283289f6600c8dac871d2c22b0a5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/011acfd466be8f7300a2e9026c3e251d5a5bace74940487e594f9ab1021ef476.jpeg",
  location: "Hoboken, NJ, USA",
  minimumOrderDollars: 80,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "A SILVER LINING, MY AUTOIMMUNE DISEASE LED ME TO CREATE SAUCE BAE.\n\nMy journey into the world of hot sauces and raw honey didn’t start in a kitchen, but from a deeply personal health challenge. At 21, I was diagnosed with Ulcerative Colitis, an autoimmune disease that drastically altered my life. Facing severe symptoms, I spent months confined to my room, wondering about my future.\n\nDetermined to reclaim my health, I embarked on a mission to understand the profound impact of diet on my condition. Through experimentation, I discovered the importance of consuming real, whole foods. This exploration ignited a passion for cooking and led to a critical realization about the food industry's shortcomings—too many products are laden with unnecessary additives and misleading claims.\n\nMotivated to make a difference, I founded Sauce Bae. I wanted to show the world that eating clean didn't have to be boring, and that simple real ingredients could create bold flavors.\n\nSauce Bae isn’t just a brand; it’s a testament to the idea that sometimes, you have to create your silver lining. As we continue to grow, we remain committed to transparency, quality, and the promise of real, all-natural ingredients—because everyone deserves a dash of flavor without compromise.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:50.922Z",
    importedBy: "entity-db-cli",
  },
};
